import { combineReducers } from "redux";
import userReducer from "./userReducer";
import searchReducer from "./searchReducers";
import domainReducer from "./domainReducer";
import trendingReducers from "./trendingReducers";
import searchHistoryReducer from "./searchHistoryReducer";
import seekerAwardsReducer from "./seekerAwardsReducer";
import recommendReducer from "./recommendReducer";
import openPageReducer from "./openPageReducer";
import answeredPageReducer from "./answeredPageReducer";
import favouritePageReducer from "./FavouritePageReducer";
import ShareByPageReducer from "./ShareByPageReducer";
import ShareWithPageReducer from "./ShareWithPageReducer";
import keytagDataReducer from "./keyTagDataReducer";
import keyTermPageReducer from "./keyTermPageReducer";
import profilePicturePageReducer from "./profilePicturePageReducer";
import ActivityReducer from "./activityReducer";
import atomizerPageReducer from "./atomizerPageReducer";
import expertOpenDataReducer from "./expertOpenDataReducer";
import editorReducer from "./editorReducer";
import myStatsReducer from "./myStatsReducer";
import knowledgeEntryPageReducer from "./knowledgeEntryPageReducer";
import expertOverviewCmReducer from "./expertOverviewCmReducer";
import sharedFolderCMReducer from "./sharedFolderCMReducer";
import drawerReducer from "./ingestedKnowledgeReducer";
import searchSuggestionsCM from "./searchSuggestionsCM";
import cmrootReducer from "./cmRootReducer";
import cmOverviewTabReducer from "./cmOverViewTab";
import seekerUserTypeReducer from "./seekerUserTypeReducer";
import documentTabReducer from "./documentOverview";
import cmExpertRecordsReducer from "./cmExpertRecordsReducer";
import slackTabReducer from "./slackTabReducer";
import generateQaReducers from "./generateQaReducers";
import manageUserReducers from "./adminManageUsersReducer";
import AdminRestrictPermission from "./restrictPermission";
import adminSettings from "./adminSettings";
import briefReducers from "./Brief";
import emailTicketReducer from "./EmailTicketReducer";

const reducers = combineReducers({
  user: userReducer,
  search: searchReducer,
  domain: domainReducer,
  searchHistory: searchHistoryReducer,
  seekerAwards: seekerAwardsReducer,
  trending: trendingReducers,
  recommend: recommendReducer,
  openQuestions: openPageReducer,
  answeredQuestions: answeredPageReducer,
  favouriteQuestions: favouritePageReducer,
  sharedBy: ShareByPageReducer,
  sharedWith: ShareWithPageReducer,
  keyTag: keytagDataReducer,
  keyTerm: keyTermPageReducer,
  profilePage: profilePicturePageReducer,
  activityData: ActivityReducer,
  expertOpenData: expertOpenDataReducer,
  editor: editorReducer,
  myStatsData: myStatsReducer,
  knowledgeEntryReducer: knowledgeEntryPageReducer,
  expertOverviewCmReducer: expertOverviewCmReducer,
  sharedFolderCMReducer: sharedFolderCMReducer,
  drawer: drawerReducer,
  searchSuggestionsCM: searchSuggestionsCM,
  cmRoot: cmrootReducer,
  atomizer: atomizerPageReducer,
  cmOverview: cmOverviewTabReducer,
  seekerType: seekerUserTypeReducer,
  documentTab: documentTabReducer,
  expertRecord: cmExpertRecordsReducer,
  slackTab: slackTabReducer,
  generateQA:generateQaReducers,
  manageUsers:manageUserReducers,
  restrictPermission: AdminRestrictPermission,
  adminSettings:adminSettings,
  brief:briefReducers,
  emailTicket:emailTicketReducer
});

export default reducers;
